import React from "react";
import moment from "moment";

export default function AssessmentTop5(props) {
  const { teamName, crrSelectedEmp, createdAt, EditButtonFn } = props;

  // 🧩 All list items defined in one array
  const top5Content = [
    "في هذا القسم، سيتم شرح كل موضوع بالتفصيل. وقد ذُكرت السلوكيات النموذجية لدى الأشخاص الناجحين الذين يتبعون هذا الموضوع.",
    "في أعلى الصفحة، ستجد الموهبة برقمها الزمني ولون محدد. يشير هذا اللون إلى ما إذا كان الموضوع من فئة القيادة، أو التمثيل، أو التواصل، أو التفكير.",
    "سيمنحك شرح المواضيع صورة واضحة عن الموهبة وكيفية تجليها. قد ترغب في إضافة المزيد إذا كنت تعتقد أن هناك شيئًا ناقصًا. بشكل عام، سيغطي هذا جوانب متعددة، ولكن قد ترغب في استكشاف المزيد بناءً على ملاحظاتك الخاصة.",
    "معرفة موهبتك شيء، لكن استثمارها شيء آخر. في هذا القسم، قدمنا ​​لك أفكارًا ومواقف حول إمكانية استغلال هذه المواهب. هذه الأفكار تُعدّ نقطة انطلاق جيدة للتفكير في طرق أخرى لاستغلال مواهبك.",
    "لكل موهبة جانبٌ خفي. مع أنك تستمتع باستغلال موهبتك، إلا أن الإفراط في استخدامها قد يُفهم أحيانًا على أنه ضعف من وجهة نظر الآخرين. من المهم أن تفهم هذا الجانب وأن تُدركه.",
    "يقدم القسم التالي من التقرير فهمًا لكيفية التعامل مع شخص لديه موضوع محدد. من المهم لنا فهم هذا الشخص والتأكد من مساعدته على إظهار أفضل ما لديه من خلال الاستفادة من موهبته وموضوعه.",
    "تذكر أنك فريد من نوعك، وأن تفردك يتجلى في مواهبك. من المهم لنا أن نتأمل في عملنا وعلاقاتنا ونجاحاتنا، والأهم من ذلك هو أن نتأمل في ما جعلنا ناجحين. ربط الأحداث بموهبتك نقطة انطلاق جيدة. وهذا ما يُسمى بالتعلم التأملي. يمكنك البدء من هنا.",
    "بعد أن تُرسّخ تعلّمك التأملي، يمكنك الانتقال إلى التعلّم الاستباقي، حيث تُحدّد أهدافك وتُحدّد المواهب التي ستستخدمها لتحقيقها. سيُتيح لك هذا أيضًا فهمًا أعمق لكيفية الاستفادة من الآخرين الذين يمتلكون موهبةً قد لا تمتلكها أنت بشكلٍ كافٍ. سيخلق هذا تآزرًا هائلًا.",
    "عندما تعرف مواهبك ويعرف أعضاء فريقك مواهبهم، فقد حان الوقت للتفكير في مواهب الفريق. إن فهم مواهب الفريق يُمكّنك من قيادة فريقك بثقة ويُساعد على إشراكهم بشكل كبير.",
    "تذكر أن عيش حياتك بموهبة هو رحلة، وكل رحلة تتطلب وقتًا. تحلَّ بالصبر واستمر في العمل على مواهب حياتك الفطرية. ستعيش حياةً مزدهرةً بلا شك.",
  ];

  return (
    <main dir="rtl" className="p-10 px-6 space-y-6 bg-white page-break">
      <div className="px-12 space-y-6 page-break">
        {/* 🧠 Header */}
        <div className="flex items-center justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
          <h1 className="text-lg font-semibold">
            {EditButtonFn("TalentAssessmentReport", "TalentPlusStrengths Assessment")}
          </h1>
          <p className="text-lg font-semibold">
            {crrSelectedEmp?.name
              ? crrSelectedEmp.name === "Team Overall"
                ? teamName
                : crrSelectedEmp.name
              : teamName}
            {createdAt && crrSelectedEmp?.name !== "Team Overall"
              ? " | " + moment(createdAt).format("DD MMM YYYY")
              : ""}
          </p>
        </div>

        {/* 🧩 Section Title */}
        <div className="w-full pb-4">
          <h1 className="text-3xl font-light text-[#212121]">
            <b>
              {EditButtonFn(
                "DeepDive",
                "Deep dive into your TalentPlusStrengths themes"
              )}            </b>
          </h1>
        </div>

        {/* 🔄 Dynamic List */}
        <div className="w-full space-y-1">
          {top5Content.map((text, index) => {
            const bgColor = index % 2 === 0 ? "bg-[#F5F5F5]" : "bg-[#E2E2E2]";
            const keyName = `top5list${index + 1}`;
            return (
              <div key={index} className={`flex p-4 ${bgColor}`}>
                <p>{index + 1}.</p>
                <p className="mx-2">{EditButtonFn(keyName, text)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}
